<template>
  <v-card class="ma-3">
    <v-card-title class="pt-3 text-left">{{ $t('developerPanel.myEms') }}</v-card-title>
    <v-card-text class="pa-0">
      <v-data-table :headers="headers" :items="emulatorData" :items-per-page="10"> </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { FusionStores } from '@fusion/saas-components-v3'
import { NAMESPACES } from '@/store/types'
import { DEVELOPER_PANEL_ACTIONS, DEVELOPER_PANEL_GETTERS } from '@/store/developerpanel'
import type { Emulator } from '@/types/emulator'
import { HTTPStatus } from '@/api'

interface EmulatorRow extends Emulator {
  last_contact: string
}

export default defineComponent({
  name: 'EmulatorTable',

  setup() {
    const notifications = FusionStores.notifications()
    return { notifications }
  },

  data() {
    return {
      headers: [
        { title: this.$t('developerPanel.tableHeaders.serial'), key: 'serial' },
        { title: this.$t('developerPanel.tableHeaders.deviceType'), key: 'model' },
        { title: this.$t('developerPanel.tableHeaders.createdAt'), key: 'created_at' },
        { title: this.$t('developerPanel.tableHeaders.lastContact'), key: 'last_contact' },
        { title: this.$t('developerPanel.tableHeaders.status'), key: 'status' }
      ]
    }
  },

  computed: {
    emulatorData(): EmulatorRow[] {
      const emulators: Emulator[] =
        this.$store.getters[
          `${NAMESPACES.DEVELOPER_PANEL}/${DEVELOPER_PANEL_GETTERS.GET_EMULATORS}`
        ]

      if (emulators.length > 0) {
        return emulators.map((emulator) => {
          let lastLog = this.$t('developerPanel.notAvailable')
          if (emulator.logs?.length > 0) {
            lastLog = emulator.logs[emulator.logs.length - 1][0].Value
          }
          return {
            ...emulator,
            last_contact: lastLog
          }
        })
      } else {
        return []
      }
    }
  },

  async mounted(): Promise<void> {
    const response = await this.$api.getAllEmulators()

    if (response.status === HTTPStatus.OK) {
      const data = await response.json()
      this.$store.dispatch(
        `${NAMESPACES.DEVELOPER_PANEL}/${DEVELOPER_PANEL_ACTIONS.SET_EMULATORS}`,
        data
      )
    } else {
      const message = {
        text: this.$t('developerPanel.apiCallFailed'),
        type: 'warning',
        timeout: -1,
        buttonText: this.$t('buttons.close'),
        status: response.status
      }
      this.notifications.addMessage(message)
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.v-data-table-footer) {
  padding: 8px 16px;
}
</style>
